import * as React from 'react';

import { TAdBannerSizes } from '../../../../types/adBannerMicrofrontend';

import * as styles from './AdBannerPlaceholder.css';

type TAdBannerPlaceholderProps = {
  sizes: TAdBannerSizes;
  testId: string;
  children?: React.ReactNode;
};

/**
 * Резервирует место под баннер, пока реклама грузится, — чтобы не было скачков вёрстки (CLS).
 */
export const AdBannerPlaceholder: React.FC<TAdBannerPlaceholderProps> = ({ sizes, testId, children }) => {
  const { width, height } = sizes;

  return (
    <div className={styles['container']} data-testid={testId} style={{ height, minHeight: height, width }}>
      {children}
    </div>
  );
};
